'use client';

import { Map } from 'immutable';

import { trackError } from '@/lib/error_tracker';

export const initialState = Map({
  flashMessage: '',
});

function setFlashMessage(state, message) {
  return state.set('flashMessage', message);
}

export function reduce(state, action) {
  switch (action.type) {
    case 'setFlashMessage':
      return setFlashMessage(state, action.data);

    default:
      trackError(state.get('session'), 'Unknown Reducer Action', null, {
        action: action.type,
      });

      return state;
  }
}
